import ApiService from "@/core/services/api.service";
// mutation types
export const LIST_SUBCONTRACTOR = "listSubcontractor"
export const SET_LIST_SUBCONTRACTOR = "setListSubcontractor"

const state = {
    listSubcontractor: null,
}

const getters = {
    ListSubcontractor: state => state.listSubcontractor,
}

const mutations = {
    [SET_LIST_SUBCONTRACTOR](state, listSubcontractor) {
        state.listSubcontractor = listSubcontractor
    }
}

const actions = {
    async [LIST_SUBCONTRACTOR](context) {
        console.log(context);
        // await ApiService.get('business-manager/registration')
        //     .then(({ data }) => {
        //         if (data.data) {
        //             context.commit(SET_LIST_SUBCONTRACTOR, data.data.data);
        //         }
        //         resolve(data);
        //     })
        //     .catch(response => {
        //         context.commit(SET_ERROR, response);
        //     });
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}